<template>
  <v-dialog
    max-width="400"
    :value="true"
    @click:outside="$emit('cancel')"
  >
    <v-card>
      <v-card-title>
        <h2>Assign Status</h2>
      </v-card-title>

      <v-card-text>
        <v-select
          v-model="selected"
          :items="options"
          label="Select One..."
          solo
        />
      </v-card-text>

      <v-card-actions>
        <button
          class="default-btn blue"
          :disabled="!selected"
          @click="$emit('submit', selected)"
        >Assign Status</button>

        <button class="default-btn text" @click="$emit('cancel')">Cancel</button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogUpdateLeadStatus',
  data: () => ({
    selected: null,
    options: [
      'Funded',
      'Lending In Progress',
      'Prospecting',
      'Client was not responsive',
      'Client was not a good fit/lead',
      'Client used a different lender',
      'Did not contact',
    ],
  }),
}
</script>

<style lang="scss" scoped></style>
